// War report screen entry (GDD §10): the ResultsScreenFactory seam used by the app flow (match/contracts.ts).

import type { ResultsScreenFactory } from '../../match/contracts'
import { ResultsScreen } from './ResultsScreen'

export const resultsScreen: ResultsScreenFactory = (report, primary, secondary) => (context) =>
  new ResultsScreen(context, report, primary, secondary)
